"use client";
import {
  Link_default
} from "./chunk-ZRVIWEMV.mjs";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/DefaultRTBs/DefaultRTBs.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DefaultRTBs = ({ referId, title, cards }) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      id: referId,
      className: "flex flex-col gap-24 lg:gap-40 justify-center items-center py-40 lg:py-80 px-24 2xl:px-0",
      children: [
        title && /* @__PURE__ */ jsx(
          "h2",
          {
            dangerouslySetInnerHTML: { __html: title },
            className: "font-display text-4xl lg:text-6xl font-bold leading-[38px] lg:leading-9 text-center"
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "flex md:grid lg:flex flex-col lg:flex-row md:grid-cols-2 gap-16 justify-center lg:justify-between items-center lg:items-stretch w-full max-w-7xl", children: cards.map((props) => /* @__PURE__ */ jsx("div", { className: "flex lg:flex-col p-16 lg:p-24 w-full rounded-[16px] lg:rounded-2xl border-2 border-display-200 hover:border-stone-200 cursor-pointer", children: /* @__PURE__ */ jsxs(Link_default, { href: { pathname: props.linkHref || props.href }, children: [
          /* @__PURE__ */ jsx("div", { className: "ml-16 min-w-max", children: /* @__PURE__ */ jsx(Icon_default, { name: props.icon, className: "w-32 h-32" }) }),
          /* @__PURE__ */ jsxs("div", { className: "lg:pt-16 pl-16 lg:pl-0", children: [
            /* @__PURE__ */ jsx("p", { className: "font-display text-lg lg:text-xl font-medium text-stone-600", children: props.title }),
            /* @__PURE__ */ jsx("p", { className: "pt-8 text-base lg:text-lg text-display-900", children: props.description })
          ] })
        ] }) })) })
      ]
    }
  );
};
var DefaultRTBs_default = DefaultRTBs;

export {
  DefaultRTBs_default
};
